import {
  ACTION_CREATE_CUSTOM_TAG__FAIL,
  ACTION_CREATE_CUSTOM_TAG__REQUEST,
  ACTION_CREATE_CUSTOM_TAG__SUCCESS,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_CUSTOM_TAG__REQUEST:
    case ACTION_CREATE_CUSTOM_TAG__SUCCESS:
      return null;

    case ACTION_CREATE_CUSTOM_TAG__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
